<ng-container *ngIf="cardToken$ | async as cardToken; else addCard">
  <div
    class="bulls-pay-button glass-bg d-flex justify-content-between align-item-center"
    [ngClass]="{
      'gloss-black': isMemberCard,
      'gloss-white': !isMemberCard,
      'bg-frozen': cardToken.Frozen
    }"
  >
    <div class="card-token-number w-100">
      <div>
        <ng-container [ngSwitch]="cardToken!.CardType">
          <img class="payment-logo" *ngSwitchCase="1" src="assets/images/payment-icons/_Mastercard.svg" />
          <img class="payment-logo" *ngSwitchCase="2" src="assets/images/payment-icons/_AMEX.svg" />
          <img class="payment-logo" *ngSwitchCase="3" src="assets/images/payment-icons/_Visa.svg" />
          <img class="payment-logo" *ngSwitchCase="4" src="assets/images/payment-icons/_Discover.svg" />
          <img class="payment-logo" *ngSwitchCase="5" src="assets/images/payment-icons/_JCB.svg" />
          <img class="payment-logo" *ngSwitchCase="7" src="assets/images/payment-icons/_DinnersClub.svg" />
          <img class="payment-logo" *ngSwitchCase="8" src="assets/images/payment-icons/_UnionPay.svg" />
          <div class="payment-logo" *ngSwitchDefault></div>
        </ng-container>
        <span class="ms-2"> ({{ cardToken?.CardNumber | creditCardNumber | slice : -4 }}) </span>
        <span class="ms-2"> {{ 'ecash.button.expiry' | translate }} {{ cardToken?.ExpiryDate | date : 'MM/yy' }} </span>
      </div>
      <div class="d-flex align-items-center">
        <ng-container *ngIf="isCardExpired && showCardExpiry">
          <div class="me-2 bg-white text-danger card-expired">{{ 'ecash.button.expired.text' | translate }}</div>
        </ng-container>

        <a
          class="d-flex"
          [routerLink]="'/ecash'"
          [ngClass]="{
            'text-black': !isMemberCard,
            'text-white': isMemberCard
          }"
        >
          <span class="icon material-symbols-outlined">keyboard_arrow_right</span>
        </a>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #addCard>
  <div class="bulls-pay-button bg-primary d-flex justify-content-center align-item-center">
    <a class="btn btn-primary d-flex align-item-center p-0" [routerLink]="'/ecash'">
      <span class="icon material-icons pe-2">add_card</span>
      <span class="mt-1">{{ 'member.card.bulls.pay.add' | translate }}</span>
    </a>
  </div>
</ng-template>
